enum AccountProviderLoginStatus {
  EXPIRED = 'EXPIRED',
  OPTED_IN = 'OPTED_IN',
}

export default AccountProviderLoginStatus;
